const config = {
  //标题
  title: 'vue2-h5',
  baseUrl: '/api',
  designWidth: 750,
  whitePathList: []
}

export default config
